const NUMERIC_REGEX = /^\d+$/;

interface PageMetadata {
  purpose: string | null;
  actions: string | null;
}

interface EntityContext {
  url: string;
  entityId: string | null;
  modelMappingHint: string;
}

/**
 * @description
 * Extracts entity identifier and audit hints from current URL path.
 * Supports an optional parameter to override the source path during rapid SPA navigation.
 *
 * @returns: {@link EntityContext} object.
 */
export function extractEntityContext(currentPathname?: string): EntityContext {
  // Se viene passato il pathname del router lo usiamo, altrimenti leggiamo dal DOM globale
  const pathname = currentPathname || new URL(document.URL).pathname;
  const url = currentPathname ? `${window.location.origin}${currentPathname}` : document.URL;

  // Rimuoviamo eventuali query string o hash dal calcolo dei segmenti (es. ?contract-edit-view_tab=0)
  const cleanPathname = pathname.split('?')[0].split('#')[0];
  const pathSegments = cleanPathname.split('/').filter(Boolean);

  const lastSegment = pathSegments.pop() ?? '';
  const isNumeric = NUMERIC_REGEX.test(lastSegment);
  const toolHint = `TOOL HINT: AuditParams: URL last numeric→object_id; Path→model_name(PascalCase, strip tenant/plurals).`;

  return {
    url,
    entityId: isNumeric ? lastSegment : null,
    modelMappingHint: toolHint
  };
}

/**
 * @description Reads page-level semantic metadata from DOM data attributes.
 *
 * @returns: {@link PageMetadata} object.
 */
export function extractPageMetadata(): PageMetadata {
  const metadataElement = document.querySelector<HTMLElement>('[data-page-description]');

  return {
    purpose: metadataElement?.getAttribute('data-page-description') ?? null,
    actions: metadataElement?.getAttribute('data-page-key-actions') ?? null
  };
}
